const { createClient } = require('@supabase/supabase-js');

class SupabaseClientWrapper {
    static create = () => {
        return createClient(
            process.env.REACT_APP_SUPABASE_SERVER,
            process.env.REACT_APP_SUPABASE_API_KEY,
        );
    }
}

export default SupabaseClientWrapper;